import React, { useEffect, useRef } from "react";
import { Application } from "../../System/Application/Application";
import "./ThreeDimAlgorithm.css";
import noisette from "url:./raw/noisette.raw";
import cerveau from "url:./raw/cerveau.raw";

import {
    webGLStart,
    changePosition,
    changeRotation,
    changeColor,
    changeTexture,
    changeWireframe,
    changeNormal,
    changeAmplitude,
    changeResolution,
    loadImage,
    resetGradients,
    handleGeneratePerlin,
    addColorToRamp,
    addMeshObj,
    addHeightmapObj,
    addBoundingBox,
    addVolumeBox,
    changeObject,
    deleteSelected,
    disposeAll,
} from "./all_scripts";

export function ThreeDimAlgorithm(props) {
    const canvasRef = useRef(null);

    useEffect(() => {
        webGLStart(canvasRef.current);

        return () => {
            // Cleanup function to dispose of WebGL resources
            disposeAll();
            // Reset the canvas reference
            canvasRef.current = null;
        };
    }, [canvasRef]);

    return (
        <Application {...props}>
            <div className="threed-algorithm-content">
                <div className="container" id="left-container">
                    <div id="position-rotation-modifier">
                        <div>
                            <h3>Object transform :</h3>
                        </div>
                        <table>
                            <thead>
                                <tr>
                                    <th>Position :</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>X :</td>
                                    <td>
                                        <input
                                            type="range"
                                            id="posX"
                                            min="-2.5"
                                            max="2.5"
                                            defaultValue="0"
                                            step="0.01"
                                            onChange={() => changePosition()}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Y :</td>
                                    <td>
                                        <input
                                            type="range"
                                            id="posY"
                                            min="-2.5"
                                            max="2.5"
                                            defaultValue="0"
                                            step="0.01"
                                            onChange={() => changePosition()}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Z :</td>
                                    <td>
                                        <input
                                            type="range"
                                            id="posZ"
                                            min="-2.5"
                                            max="2.5"
                                            defaultValue="0"
                                            step="0.01"
                                            onChange={() => changePosition()}
                                        />
                                    </td>
                                </tr>
                            </tbody>
                            <thead>
                                <tr>
                                    <th>Rotation :</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>X :</td>
                                    <td>
                                        <input
                                            type="range"
                                            id="rotX"
                                            min="-180"
                                            max="180"
                                            defaultValue="0"
                                            step="1"
                                            onChange={() => changeRotation()}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Y :</td>
                                    <td>
                                        <input
                                            type="range"
                                            id="rotY"
                                            min="-180"
                                            max="180"
                                            defaultValue="0"
                                            step="1"
                                            onChange={() => changeRotation()}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Z :</td>
                                    <td>
                                        <input
                                            type="range"
                                            id="rotZ"
                                            min="-180"
                                            max="180"
                                            defaultValue="0"
                                            step="1"
                                            onChange={() => changeRotation()}
                                        />
                                    </td>
                                </tr>
                            </tbody>
                            <thead>
                                <tr>
                                    <th>Color :</th>
                                    <th>
                                        <input
                                            type="color"
                                            id="color"
                                            defaultValue="#ffffff"
                                            onChange={() => changeColor()}
                                        />
                                    </th>
                                </tr>
                            </thead>
                            <thead>
                                <tr>
                                    <th>Use texture :</th>
                                    <th>
                                        <input
                                            type="checkbox"
                                            id="texture"
                                            defaultChecked={false}
                                            onChange={() => changeTexture()}
                                        />
                                    </th>
                                </tr>
                            </thead>
                            <thead>
                                <tr>
                                    <th>Wireframe :</th>
                                    <th>
                                        <input
                                            type="checkbox"
                                            id="wireframe"
                                            defaultChecked={false}
                                            onChange={() => changeWireframe()}
                                        />
                                    </th>
                                </tr>
                            </thead>
                            <thead>
                                <tr>
                                    <th>Use normal map :</th>
                                    <th>
                                        <input
                                            type="checkbox"
                                            id="normal"
                                            defaultChecked={false}
                                            onChange={() => changeNormal()}
                                        />
                                    </th>
                                </tr>
                            </thead>
                            <thead>
                                <tr>
                                    <th>Height Amplitude</th>
                                    <th>
                                        <input
                                            type="range"
                                            id="amplitude"
                                            min="0.0"
                                            max="0.5"
                                            defaultValue="0.1"
                                            step="0.01"
                                            onChange={() => changeAmplitude()}
                                        />
                                    </th>
                                </tr>
                            </thead>
                            <thead>
                                <tr>
                                    <th>Resolution</th>
                                    <th>
                                        <input
                                            type="range"
                                            id="resolution"
                                            min="128.0"
                                            max="2048.0"
                                            defaultValue="512.0"
                                            step="64.0"
                                            onChange={() => changeResolution()}
                                        />
                                    </th>
                                </tr>
                            </thead>
                        </table>

                        <div id="heightmap">
                            <h3>Heightmap :</h3>
                            <table>
                                <thead>
                                    <tr>
                                        <th>From texture :</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            <button
                                                onClick={() =>
                                                    loadImage("texture1.png")
                                                }
                                            >
                                                Texture 1
                                            </button>
                                            <button
                                                onClick={() =>
                                                    loadImage("texture2.png")
                                                }
                                            >
                                                Texture 2
                                            </button>
                                            <button
                                                onClick={() =>
                                                    loadImage("texture3.png")
                                                }
                                            >
                                                Texture 3
                                            </button>
                                            <button
                                                onClick={() =>
                                                    loadImage("texture4.png")
                                                }
                                            >
                                                Texture 4
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                                <thead>
                                    <tr>
                                        <th>Perlin Noise :</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            <div id="perlin-parameters">
                                                <button
                                                    onClick={() =>
                                                        resetGradients()
                                                    }
                                                >
                                                    Reset Gradients
                                                </button>
                                                <br />
                                                <label htmlFor="perlin-rgb">
                                                    RGB
                                                </label>
                                                <input
                                                    type="checkbox"
                                                    id="perlin-rgb"
                                                    defaultChecked={false}
                                                    onChange={() =>
                                                        handleGeneratePerlin()
                                                    }
                                                />
                                                <br />
                                                <label htmlFor="perlin-scale">
                                                    Scale
                                                </label>
                                                <input
                                                    type="range"
                                                    id="perlin-scale"
                                                    min="0.001"
                                                    max="0.05"
                                                    defaultValue="0.01"
                                                    step="0.0005"
                                                    onChange={() =>
                                                        handleGeneratePerlin()
                                                    }
                                                />
                                                <br />
                                                <label htmlFor="perlin-amplitude">
                                                    Amplitude
                                                </label>
                                                <input
                                                    type="range"
                                                    id="perlin-amplitude"
                                                    min="0"
                                                    max="5"
                                                    defaultValue="2"
                                                    step="0.01"
                                                    onChange={() =>
                                                        handleGeneratePerlin()
                                                    }
                                                />
                                                <br />
                                                <label htmlFor="perlin-persistence">
                                                    Persistence
                                                </label>
                                                <input
                                                    type="range"
                                                    id="perlin-persistence"
                                                    min="0"
                                                    max="1"
                                                    defaultValue="0.5"
                                                    step="0.01"
                                                    onChange={() =>
                                                        handleGeneratePerlin()
                                                    }
                                                />
                                                <br />
                                                <label htmlFor="perlin-octaves">
                                                    Octaves
                                                </label>
                                                <input
                                                    type="range"
                                                    id="perlin-octaves"
                                                    min="0"
                                                    max="10"
                                                    defaultValue="8"
                                                    step="0.01"
                                                    onChange={() =>
                                                        handleGeneratePerlin()
                                                    }
                                                />
                                                <br />
                                                <label htmlFor="perlin-contrast">
                                                    Contrast
                                                </label>
                                                <input
                                                    type="range"
                                                    id="perlin-contrast"
                                                    min="0"
                                                    max="2"
                                                    defaultValue="1"
                                                    step="0.01"
                                                    onChange={() =>
                                                        handleGeneratePerlin()
                                                    }
                                                />
                                                <br />
                                                <button
                                                    onClick={() =>
                                                        handleGeneratePerlin()
                                                    }
                                                >
                                                    Generate
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div id="color-heightmap"></div>
                    </div>
                </div>
                <div
                    className="container"
                    id="center-container"
                    style={{ maxWidth: "52%" }}
                >
                    <div className="content" style={{ maxHeight: "60%" }}>
                        <canvas
                            id="WebGL-test"
                            style={{
                                border: "none",
                                maxHeight: "calc(100% - 35px)",
                                userSelect: "none",
                            }}
                            width="1920"
                            height="1080"
                            onContextMenu={() => {
                                return false;
                            }}
                            ref={canvasRef}
                            onLoad={() => {
                                canvasRef.current.width = window.innerWidth;
                                canvasRef.current.height = window.innerHeight;
                            }}
                        ></canvas>
                        <button
                            style={{
                                position: "relative",
                                left: "50%",
                                transform: "translateX(-50%)",
                            }}
                            onClick={() =>
                                canvasRef.current.requestFullscreen()
                            }
                        >
                            Fullscreen
                        </button>
                    </div>
                    <div
                        id="hm-right-part"
                        className="content"
                        style={{ maxHeight: "38%" }}
                    >
                        <div>
                            <h3 className="content">Heightmap : </h3>
                            <canvas
                                id="heightmap-result"
                                width="512"
                                height="512"
                                style={{ border: "none" }}
                            ></canvas>
                        </div>
                        <div>
                            <h3 className="content">Volume : </h3>
                            <input
                                type="range"
                                id="cr_min_threshold"
                                min="0.0"
                                max="1.0"
                                defaultValue="0.1"
                                step="0.00392157"
                            />
                            <input
                                type="range"
                                id="cr_max_threshold"
                                min="0.0"
                                max="1.0"
                                defaultValue="0.1"
                                step="0.00392157"
                            />
                            <h3 className="content">ColorsRamp : </h3>
                            <table id="colors-ramp">
                                <thead>
                                    <tr>
                                        <th>Color</th>
                                        <th>Threshold</th>
                                        <th>Actions</th>
                                    </tr>
                                    <tr>
                                        <td>
                                            <input
                                                type="color"
                                                defaultValue="#ffffff"
                                                id="cr-color-add"
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="range"
                                                min="0.00392157"
                                                max="0.99607843"
                                                defaultValue="0.5"
                                                step="0.00392157"
                                                id="cr-threshold-add"
                                            />
                                        </td>
                                        <td>
                                            <button
                                                onClick={() => addColorToRamp()}
                                            >
                                                Add
                                            </button>
                                        </td>
                                    </tr>
                                </thead>
                                <tbody id="colors-ramp-body">
                                    <tr className="cr-color-special">
                                        <td>
                                            <input
                                                type="color"
                                                defaultValue="#C7E0E8"
                                                id="cr-color-min"
                                            />
                                        </td>
                                        <td>
                                            <input
                                                disabled
                                                type="range"
                                                min="0.0"
                                                max="1.0"
                                                defaultValue="0.0"
                                                id="cr-threashold-min"
                                            />
                                        </td>
                                        <td>
                                            <button disabled>Delete</button>
                                        </td>
                                    </tr>
                                    <tr className="cr-color-special">
                                        <td>
                                            <input
                                                type="color"
                                                defaultValue="#00000"
                                                id="cr-color-max"
                                            />
                                        </td>
                                        <td>
                                            <input
                                                disabled
                                                type="range"
                                                min="0.0"
                                                max="1.0"
                                                defaultValue="1.0"
                                                id="cr-threashold-max"
                                            />
                                        </td>
                                        <td>
                                            <button disabled>Delete</button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div className="container" id="right-container">
                    <div id="selector">
                        <h3>Scene objects :</h3>
                        <select
                            id="object-selector"
                            multiple
                            onChange={() => changeObject()}
                        ></select>
                        <button
                            className="content"
                            onClick={() => deleteSelected()}
                        >
                            Remove Object
                        </button>
                        <h3>Add objects :</h3>
                        <div id="objects-selector">
                            <button onClick={() => addMeshObj("bunny.obj")}>
                                Stanford's Bunny
                            </button>
                            <button onClick={() => addMeshObj("mustang.obj")}>
                                Mustang
                            </button>
                            <button onClick={() => addMeshObj("porsche.obj")}>
                                Porsche
                            </button>
                            <button onClick={() => addMeshObj("sphere.obj")}>
                                Sphere
                            </button>
                            <button onClick={() => addHeightmapObj()}>
                                Heightmap
                            </button>
                            <button onClick={() => addBoundingBox()}>
                                BoundingBox
                            </button>
                            <button
                                onClick={() =>
                                    addVolumeBox(
                                        noisette,
                                        512,
                                        512,
                                        512,
                                        "VolumeBox Hazelnut"
                                    )
                                }
                            >
                                VolumeBox Hazelnut (Heavy to load)
                            </button>
                            <button
                                onClick={() =>
                                    addVolumeBox(
                                        cerveau,
                                        704,
                                        704,
                                        208,
                                        "VolumeBox Cerveau"
                                    )
                                }
                            >
                                VolumeBox Head/Brain (Heavy to load)
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </Application>
    );
}
